<template>
<div v-if="ready" style="padding:20px 20px 20px 20px;">
  <schedaHeader scheda="6" titolo="TRASFERIMENTO" :item="item"></schedaHeader>
  
  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="360px" class="label-50">



   <div class="formRow row">

<div class="col s12" v-if="item.row.fdisp==2">       <formLabel variabile="transcode"></formLabel>       <el-form-item prop="transcode">       <formSelectV3 v-model="item.row.transcode" variabile="transcode"></formSelectV3>       </el-form-item>       </div>


<!--
  <div class="col s12" v-if="item.row.fdisp==2">       <formLabel variabile="xfer_ctr"></formLabel>       <el-form-item prop="xfer_ctr">       <formInputfromanswer v-model="item.row.xfer_ctr" variabile="xfer_ctr"></formInputfromanswer>       </el-form-item>       </div>
-->

<!-- v-if="item.row.locate==1" tolto su richiesta di adele -->
      <div class="col s12" >
      <formLabel variabile="xfer_ctr"></formLabel>
      <el-form-item prop="xfer_ctr" >
        <el-select v-model="item.row.xfer_ctr"  placeholder="Selezionare dalla lista" style="width:100%;" clearable filterable>
          <el-option label="Altro centro" :value="-5"></el-option>
          <el-option v-for="itm in $teras._struttura" :key="itm.id" :label="itm.id+' - '+itm.nome+' - '+itm.regione+' - '+itm.citta" :value="itm.id" >
            <span style="float: left">{{ itm.id }} - {{ itm.nome }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ itm.regione }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </div> 



<div class="col s12" v-if="item.row.fdisp==2">       <formLabel variabile="f2disp"></formLabel>       <el-form-item prop="f2disp">       <formSelectV3 v-model="item.row.f2disp" variabile="f2disp"></formSelectV3>       </el-form-item>       </div>

<!--
# PER IL VON 

udisp = -7
f3wgt = -7
f3disp = -7

se fdisp == 2
  lostot = -9 

se fdisp != 2
  lostot = -7
  
   

<div class="col s12" v-if="item.row.f2disp==2 || item.rowf3disp==2">       <formLabel variabile="udisp"></formLabel>       <el-form-item prop="udisp">       <formSelectV3 v-model="item.row.udisp" variabile="udisp"></formSelectV3>       </el-form-item>       </div>
<div class="col s12" v-if="item.row.fdisp==2">       <formLabel variabile="lostot"></formLabel>       <el-form-item prop="lostot">       <formInputfromanswer v-model="item.row.lostot" variabile="lostot"></formInputfromanswer>       </el-form-item>       </div>
-->
      <div class="col s12" v-if="item.row.f2disp==4">
        <div style="padding:16px;">
        Riaggiornare i campi in precedenza compilati tenendo conto di quanto successo nell'ospedale in cui il bambino era stato trasferito!
        </div>
      </div>
      <div class="col s12" v-if="item.row.f2disp==4">       <formLabel variabile="f3disp"></formLabel>       <el-form-item prop="f3disp">       <formSelectV3 v-model="item.row.f3disp" variabile="f3disp"></formSelectV3>       </el-form-item>       </div>

      <div class="col s12" v-if="item.row.f2disp!=-9">       
         <formLabel variabile="dfd"></formLabel>       
         <el-form-item prop="dfd">       
         <el-date-picker v-model="item.row.dfd" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>       
         </el-form-item>       
      </div>

      <div class="col s12" v-if="item.row.f2disp!=-9 && $moment(item.row.dfd)>=$moment(item.row.dataricovero) ">
         <formLabel variabile="lostot"></formLabel>
         <el-form-item prop="lostot">
         <div class="yo-align-left" style="padding-left:12px;"><!-- {{item.row.dfd}} » {{item.row.fdisp}} » {{item.row.f2disp}} » -->{{$moment(item.row.dfd).diff( $moment(item.row.dataricovero) ,'days')+1}}</div>
         </el-form-item>
      </div>

      
      
      
      <div class="col s12" v-if="item.row.f2disp==4">       <formLabel variabile="f3wgt"></formLabel>       <el-form-item prop="f3wgt">       <formRangeV3 v-model="item.row.f3wgt" variabile="f3wgt" ></formRangeV3>      </el-form-item>       </div>





   </div>

    <div v-if="item.row.chiusoil=='0000-00-00 00:00:00'" class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
        </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva</el-button>
      </div>
    </div>

    <div v-else class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="$router.push('/home')">Annulla</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
/*
QUERY
SELECT id,LOWER(nome),posizione,tipo,risposte,answer,nc,na,domanda,help FROM `variabile` WHERE scheda=6 ORDER BY posizione
*/
import schedaHeader from './Scheda-header.vue'
import formLabel from './Form-label.vue'
import formSelectV3 from './Form-select-v3.vue'
import formRangeV3 from './Form-range-v3.vue'

import dbItem from '../teras/dbItem'

export default {
  name: 'scheda-datigenerali',
  components: {
     schedaHeader
     ,formLabel
     ,formSelectV3
     ,formRangeV3
  },
  data() {
    return {
      loading:{}
      ,ready: false
      ,item:{}
      ,rowBanca:[]
    }
  },
  created: async function () {
    console.log("Arrivo  scheda-datigenerali.vue con id "+this.$route.params.id)
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    this.item = new dbItem({table:'paziente'})
    await this.item.load(this.$route.params.id)
    if(this.item.row.centro==0)
      this.item.row.centro = this.$centro.referente.row.centro

    if(this.item.rowIsNew){
      this.item.row.creatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
      this.item.row.creatoda=this.$teras.utente.id//this.$centro.referente.row.id

      this.item.row.byear = this.$moment().format('YYYY')
    }else{
      //mettere il nome della pagina cme modifica
    }

    for (let property in this.item.row){
      if(this.item.row[property]==-7)
        this.item.row[property]=-127
    }

    if(this.item.row.dfd=='0000-00-00')
      this.item.row.dfd=''//this.$moment().format('YYYY-MM-DD H:mm:ss')
    if(this.$moment(this.item.row.dfd).format('YYYY')<2019)
      this.item.row.dfd=''

    setTimeout(() =>{ 
      this.loading.close()
      this.ready = true 
    }, 1000)


  },
  methods: {
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          
          this.item.row.modificatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
          this.item.row.modificatoda=this.$teras.utente.id//this.$centro.referente.row.id

          let error = -1

          if(this.item.row.f2disp!=-9 && this.$moment(this.item.row.dataesito) > this.$moment(this.item.row.dfd).add(0,'days'))
            error = 103

          if(this.$moment(this.item.row.dataesito) > this.$moment(this.item.row.datanascita).add(364,'days'))
            error = 104

          switch (error){
            case -1:
            this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
            if(this.item.row.chiusoil=='0000-00-00 00:00:00'){
              await this.item.save()
              await this.$axios.query('doQuery',`CALL paziente_check_risposte(←id,@nome, @numero);`,{id: this.item.row.id})
              await this.$centro.getPaziente()
            }
            this.loading.close()
            this.$router.push('/home/')
            break;

            case 103:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno ultimo di dimissione deve essere successivo alla data di trasferimento!'})
            break;

            case 104:
            this.$notify.error({title: 'Errore '+error,message: 'Il giorno di esito deve essere minore o uguale al primo anno di età del bambino!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'})
          }


          
          
        } else {
          this.$notify.error({title: 'Errore',message: "Non tutti i campi sono stati compilati correttamente!"})
          return false
        }
      })
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/home/')
    }

  },
  computed: {
    rulesForm:function() {
      var rulesNow = {

      }
      return rulesNow
    }
  }
}
</script>
<style >
.formRow{

}.formRow > .col {
    background-color: #F9F9FA;
}.formRow > .col:nth-child(odd) {
    background-color: #EFF0F2;
}.formRow > .col .el-form-item{
  margin-top:10px;
  margin-bottom:18px;
}.formRow > .col .el-form-item__content{
  margin-right:12px;

  
}
</style>